import React, { FC, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { VbzDropdown, VbzInputText, VbzRadio } from "@smiles/voebiz-ui-kit";

import { RegisterContent, IconLockOutline } from "../../../../components";

import { DropdownsItems, handleFormChangeF, InfoForm, YesNoRadios } from "../type";

interface CompanyInfoProps {
  data: InfoForm;
  returnPath: string;
  onChange: handleFormChangeF;
  dropdowns: DropdownsItems;
}

const CompanyInfo: FC<CompanyInfoProps> = ({ data, returnPath, onChange, dropdowns }) => {
  const { t } = useTranslation("register_company");
  const history = useHistory();
  const [formData, setFormData] = useState<InfoForm>({ ...data });

  const pageReturn = () => {
    if (!formData.cnpj || formData.cnpj === "00.000.000/0000-00") {
      history.push(returnPath);
    }
  };
  useEffect(() => {
    pageReturn();
  }, []);

  useEffect(() => {
    onChange("info", formData);
  }, [formData]);

  const renderYesNoRadios = ({ title, name }: YesNoRadios) => (
    <div className="inputTextContainer">
      <legend className="voebiz-register_content_default_description">{t(title)}</legend>
      <div className="voebiz-relationship_with_gol_container">
        <VbzRadio
          id={`${name}Positive`}
          name={name}
          label="Sim"
          onChange={() => setFormData((prevState) => ({ ...prevState, [name]: "Y" }))}
          checked={formData[name] === "Y" ?? false}
        />
        <VbzRadio
          id={`${name}Negative`}
          name={name}
          label="Não"
          onChange={() => setFormData((prevState) => ({ ...prevState, [name]: "N" }))}
          checked={formData[name] === "N" ?? true}
        />
      </div>
    </div>
  );
  const renderDropdowns = () => {
    return Object.keys(dropdowns).map((key) => {
      const { stateName, items } = dropdowns[key as keyof DropdownsItems];
      return (
        <div className="inputTextContainer" key={stateName} data-testid={`${stateName}-test-id`}>
          <VbzDropdown
            id={`inp_${key}`}
            placeholder={t(`input.dropdown.${key}.placeholder`)}
            textMobile={t(`input.dropdown.${key}.placeholder`)}
            openWhenTyping
            textLabel={t(`input.dropdown.${key}.label`)}
            errorMessage={t(`input.dropdown.${key}.error`)}
            onClick={(value) => {
              const result = items.find((item) => item.description === value);
              if (result && result.id) {
                if (stateName === "mainActivity") {
                  setFormData((prevState) => ({
                    ...prevState,
                    mainActivityDesc: result.description,
                    mainActivity: result.id,
                  }));
                }
                setFormData((prevState) => ({
                  ...prevState,
                  [stateName]: result.description,
                }));
              } else {
                setFormData(data);
              }
            }}
            actions={items.map((item) => ({ name: item.description }))}
            defaultValue={formData[stateName]}
          />
        </div>
      );
    });
  };
  return (
    <div className="voebiz-register-cnpj voebiz-register-cnpj-section-1">
      <div className="voebiz-title-wrapper">
        <h3 className="title-wrapper" id="lbl_titleCompany">
          {t("data_title")}
        </h3>
      </div>
      <div className="voebiz-content-wrapper">
        <RegisterContent idMessage="lbl_msgInformativeCompanyData" text={t("data_description")} label={t("data_label")}>
          <div className="voebiz-company-container-data-fields">
            <div className="voebiz-company-container-data-fields-right">
              <div className="inputTextContainer">
                <VbzInputText
                  id="input_cnpj"
                  value={formData.cnpj}
                  maxLength={18}
                  disabled
                  inputMode="numeric"
                  regex={/[^0-9./-]/gi}
                  icon={<IconLockOutline />}
                  textLabel={t("input.text.cnpj.label")}
                />
              </div>
              <div className="inputTextContainer">
                <VbzInputText
                  id="inp_company_name"
                  placeholder={t("input.text.company_name.placeholder")}
                  onChange={(e) => setFormData((prevState) => ({ ...prevState, socialReason: e.target.value }))}
                  value={formData.socialReason}
                  textLabel={t("input.text.company_name.label")}
                />
              </div>
              <div className="inputTextContainer">
                <VbzInputText
                  id="inp_fantasy_name"
                  placeholder={t("input.text.fantasy_name.placeholder")}
                  onChange={(e) => setFormData((prevState) => ({ ...prevState, fantasyName: e.target.value }))}
                  value={formData.fantasyName}
                  textLabel={t("input.text.fantasy_name.label")}
                />
              </div>
              {renderDropdowns()}
              {renderYesNoRadios({
                title: "input.radio.radio_relationship_with_gol.label",
                name: "relationshipWithGOL",
              })}
              {formData.relationshipWithGOL === "Y" && (
                <>
                  {renderYesNoRadios({
                    title: "input.radio.has_provided_services_to_gol.label",
                    name: "providedServicesToGol",
                  })}
                  {renderYesNoRadios({
                    title: "input.radio.has_provided_services_to_others.label",
                    name: "providedServicesToOthers",
                  })}
                </>
              )}
            </div>
          </div>
        </RegisterContent>
      </div>
    </div>
  );
};

export default CompanyInfo;
